import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../../store/slices/authSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { RouteNames } from "../../../navigation/RouteNames";
import { useTranslation } from "../../../translations/i18n";

export const useForgotPasswordScreen = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { loading, error, fieldErrors } = useAppSelector((state) => state.auth);

  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (event?: FormEvent) => {
    event?.preventDefault();
    setSuccessMessage("");

    const result = await dispatch(forgotPassword({ email }));

    if (forgotPassword.fulfilled.match(result)) {
      setSuccessMessage(result.payload);
    }
  };

  return {
    email,
    setEmail,

    loading,
    error: error || "",
    emailError: fieldErrors.email?.[0] || "",
    successMessage,

    handleSubmit,
    goToLogin: () => navigate(RouteNames.login),

    t,
  };
};
